"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CollapseInfoThreeColumn;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _PopoverAndOverlay = require("./PopoverAndOverlay");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function CollapseInfoThreeColumn(_ref) {
  var {
    className,
    label,
    total,
    id,
    contentArray,
    openToStart,
    labelPopover,
    labelPopoverId
  } = _ref;
  // Initialize arrowUpOrDown based on openToStart prop
  var [arrowUpOrDown, setArrowUpOrDown] = (0, _react.useState)(openToStart ? 'up' : 'down');
  var arrowUpOrDownCode = arrowUpOrDown === 'up' ? '0' : '';

  // Handle arrow direction on click (i.e. this will flip the arrow(s)/chevron(s) up and down)
  var handleItemClick = eventKey => () => {
    setArrowUpOrDown(eventKey === 'up' ? 'down' : 'up');
  };

  // Create object container id
  var rowIdAssigner = id ? {
    id: id
  } : null;
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    className: "".concat(className, " card--flat")
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, {
    className: "calculators"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Text, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse, {
    defaultActiveKey: arrowUpOrDownCode
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Group, {
    className: "calculators"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Toggle, {
    eventKey: "0",
    open: arrowUpOrDownCode === '0' ? true : false,
    onClick: handleItemClick(arrowUpOrDown)
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "calc--info-text row null-x-margin align-items-center"
  }, rowIdAssigner), /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement("span", null, (0, _htmlReactParser.default)(label), labelPopover && /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: labelPopoverId,
    text: labelPopover
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "mm-text-right"
  }, /*#__PURE__*/_react.default.createElement("strong", null, total))))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Collapse, {
    eventKey: "0"
  }, contentArray.map((content, index) => {
    var idAssigner = content.id ? {
      id: content.id
    } : null;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", _extends({
      className: "calc--info-text row null-x-margin align-items-center"
    }, idAssigner), /*#__PURE__*/_react.default.createElement("div", {
      className: content.value1 ? 'col-5' : 'col-7'
    }, /*#__PURE__*/_react.default.createElement("span", null, (0, _htmlReactParser.default)(content.label)), content.popoverText && /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
      fieldName: content.popoverId,
      text: content.popoverText
    })), content.value1 ? /*#__PURE__*/_react.default.createElement("div", {
      className: "col-4"
    }, /*#__PURE__*/_react.default.createElement("span", null, (0, _htmlReactParser.default)(content.value1))) : '', /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(content.value1 ? 'col-3' : 'col-5', " mm-text-right padding-left-0")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "mm-text-right"
    }, (0, _htmlReactParser.default)(content.value2)))), content.hr ? /*#__PURE__*/_react.default.createElement("hr", null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  })))))));
}